import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Component({
  selector: 'redirect-to-login-or-register-dialog',
  templateUrl: 'redirect-to-login-or-register-dialog.html',
  styleUrls: ['./redirect-to-login-or-register-dialog.scss'],
  standalone: false
})
export class RedirectToLoginOrRegisterDialog {
  private authService = inject(AuthService);

  constructor() { }

  async signin() {
    await this.authService.login();
  }
}
